import { RendererFilter } from '@report-content';

const formFieldPrefix = '__field__name_';

export function getFieldOptionForFormName(field: RendererFilter, option: string) {
    return formFieldPrefix + field.column_name + '_' + option;
}
